import * as AppPics from 'assets/images';
import { CourseMenuContext } from 'context/CourseSubMenu';
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom';

function CoursesSubLinks() {
  const { classID, courseID } = useParams();
  const { menu } = useContext(CourseMenuContext);
  const { showMenu, showContentsSubMenu, ...rest } = menu || {};
  const courseActive = Object.values(rest).some((x) => x === true);

  return (
    <>
      <NavLink
        to="/courses"
        exact
        className="menuWrap__menu"
        activeClassName="active"
        isActive={(match) => {
          if (courseActive) return true;

          if (match?.url === '/courses') return true;

          if (!match) {
            return false;
          }

          return courseActive;
        }}
      >
        <img src={AppPics.AcademicCapSvg} alt="" />
        <span className="menuWrap__menuName">Courses</span>
      </NavLink>
      <ul className={`menuWrap__menuSub ${menu.showMenu ? '' : 'd-none'}`}>
        <li>
          <a href="#content">Course Content</a>
          {showContentsSubMenu && (
            <ul className="menuWrap__menuSub submenutwo">
              <li className={`${menu.isDiscover ? 'active' : ''}`}>
                {' '}
                <Link to={`/classes/${classID}/courses/${courseID}/chapters`}>Discover</Link>{' '}
              </li>
              <li className={`${menu.isAssess ? 'active' : ''}`}>
                {' '}
                {/* <Link to="/manage/quiz">Assess</Link> */}
                <Link to={`/classes/${classID}/courses/${courseID}/assess`}>Assess</Link>{' '}
              </li>
              <li className={`${menu.isPerform ? 'active' : ''}`}>
                {' '}
                <Link to={`/classes/${classID}/courses/${courseID}/perform`}>Perform</Link>{' '}
              </li>
              {/* <li className={`${menu.isFunFactor ? 'active' : ''}`}>
                {' '}
                <Link to={`classes/${classID}/courses/${courseID}/chapters`}>Discover</Link>{' '}
              </li> */}
            </ul>
          )}
        </li>
        <li className={`${menu.isInSights ? 'active' : ''}`}>
          <a href="#insights">Course Insights</a>
        </li>
        <li className={`${menu.isSettings ? 'active' : ''}`}>
          <a href="#settings">Course Settings</a>
        </li>
      </ul>
    </>
  );
}

export default CoursesSubLinks;
